import {applicationName} from "../utils";

export const CHANGE_NAVIGATE = "CHANGE_NAVIGATE";//切换导航
export const LOAD_NAVIGATE_DATA = "LOAD_NAVIGATE_DATA";//加载导航数据
export const UPDATE_NAVIGATE_DATA = "UPDATE_NAVIGATE_DATA";//更新导航数据
export const CHANGE_NAVIGATE_STAUTS = "CHANGE_NAVIGATE_STAUTS";//收缩/展开导航
export const SHRIN_NAVIGATE_STAUTS = "SHRIN_NAVIGATE_STAUTS";//收缩导航
export const SHRIN_MIN_LENGTH = 1366;//当小于1366的时候，导航自动收缩
export const AUTO_CHANGE_NAVIGATE_STAUTS = "AUTO_CHANGE_NAVIGATE_STAUTS";//自动收缩导航
export const LOAD_CURRENT_USER = "LOAD_CURRENT_USER";//加载当前用户信息
export const LOAD_SYSTEM_CONFIG = "LOAD_SYSTEM_CONFIG";//加载系统的配置信息
export const REFRESH_PAGE = "REFRESH_PAGE";//刷新当前页面
export const CHANG_ZYK_SEARCH_TEXT = "CHANG_ZYK_SEARCH_TEXT";//写稿处资源库搜索内容修改
export const ZYK_STORY_COUNT = "ZYK_STORY_COUNT";//资源库中稿件的数量
export const ZYK_PICTURE_COUNT = "ZYK_PICTURE_COUNT";//资源库中图片的数量
export const ZYK_AUDIO_COUNT = "ZYK_AUDIO_COUNT";//资源库中音频的数量
export const CONTENT_PICTURE_COUNT = "CONTENT_PICTURE_COUNT";//资源库中稿件内容图片的数量
export const ZYK_VIDEO_COUNT = "ZYK_VIDEO_COUNT";//资源库中视频的数量
export const ZYK_DOCUMENT_COUNT = "ZYK_DOCUMENT_COUNT";//资源库中文档的数量
export const NO_FRAME = "no-frame";//单独显示组件，页面中没有导航和顶部
export const HEADER_HEIGHT = "70";//顶部导航的高度
export const UPDATE_NAVIGATE_LEVEL2_DATA = "UPDATE_NAVIGATE_LEVEL2_DATA";//更新二级导航数据
export const NAVIGATE_OPEN = "240";//左侧导航展开时的宽度
export const NAVIGATE_CLOSE = "70";//左侧导航收起时的宽度
export const NAVIGATE_LEVEN2_WIDTH = "240";//二级导航宽度
export const NAVIGATE_LEVEN2_MARGIN = "15";//二级导航距离一级导航的间隙宽度
export const NAVIGATE_LEVEN2_ENABLE = applicationName() === "pms";//是否开启二级导航
export const UPDATE_STORY_PARAMS = "UPDATE_STORY_PARAMS";//是否开启二级导航
export const LOAD_STORAGE_PIC_DATA = "LOAD_STORAGE_PIC_DATA";//加载云存储中图片数据
export const LOAD_STORAGE_VIDEO_DATA = "LOAD_STORAGE_VIDEO_DATA";//加载云存储中视频数据
export const LOAD_STORAGE_AUDIO_DATA = "LOAD_STORAGE_AUDIO_DATA";//加载云存储中音频数据
export const LOGO_HEIGHT = 60;//logo的高度
export const SYSTEM_STATUS = "SYSTEM_STATUS";//系统加载的状态
export const EDITOR_TOOL_BTN_COLOR = { // 编辑器工具栏按钮颜色
    checked: "#BDB7B7",
    hover: "#D9D7D9",
    press: "#BDB7B7"
};

Object.defineProperty(Array.prototype, "toUpperCase", {
    value: function(){
        if(this){
            return this.map(item=>item.toUpperCase());
        }
    },
    enumberable : false
});

export const VIDEO_TYPE_ORIGINAL = ["avi","mp4","mov","mkv","rmvb","flv","rm","mpeg","mpg","ogv","wmv","webm"];//视频类型
export const VIDEO_TYPE = [...VIDEO_TYPE_ORIGINAL, ...VIDEO_TYPE_ORIGINAL.toUpperCase()];//视频类型
export const VIDEO_TYPE_STR = VIDEO_TYPE.join(",");//视频类型

export const AUDIO_TYPE_ORIGINAL =["mp3","ogg","wav"];
export const AUDIO_TYPE = [...AUDIO_TYPE_ORIGINAL, ...AUDIO_TYPE_ORIGINAL.toUpperCase()];//音频类型
export const AUDIO_TYPE_STR = AUDIO_TYPE.join(",");//音频类型

export const ATTCHMENT_TYPE_ORIGINAL = ["swf","doc","docx","ppt","pptx","xls","xlsx","psd","txt","rar","zip","pdf","tar","gz","7z","bz2","cab","iso","md","xml","json"];
export const ATTCHMENT_TYPE = [...ATTCHMENT_TYPE_ORIGINAL, ...ATTCHMENT_TYPE_ORIGINAL.toUpperCase()];//附件类型
export const ATTCHMENT_TYPE_STR = ATTCHMENT_TYPE.join(",");//附件类型
export const PIC_TYPE_ORIGINAL = ["jpg","jpeg","gif","png","bmp","webp","webp2","tiff","tif"];
export const PIC_TYPE = [...PIC_TYPE_ORIGINAL, ...PIC_TYPE_ORIGINAL.toUpperCase()];//图片类型
export const PIC_TYPE_ORIGINAL_WECHAT = ["bmp","png","jpeg","jpg","gif"];//微信图片类型
export const PIC_TYPE_WECHAT = [...PIC_TYPE_ORIGINAL_WECHAT, ...PIC_TYPE_ORIGINAL_WECHAT.toUpperCase()];//微信图片类型
export const PIC_TYPE_STR = PIC_TYPE.join(",");//图片类型

export const PIC_TYPE_NEW = ["jpg","jpeg","gif","png","bmp","pdf"];
export const PIC_TYPE_PDF = [...PIC_TYPE_NEW, ...PIC_TYPE_NEW.toUpperCase()];//图片和pdf
export const PIC_PDF_STR = PIC_TYPE_PDF.join(",");//图片和pdf

export const ONLY_PIC_TYPE_NEW = ["jpg","jpeg","png","bmp"];

export const FILE_TYPE = [...VIDEO_TYPE, ...AUDIO_TYPE, ...PIC_TYPE, ...ATTCHMENT_TYPE];//所有文件类型
export const FILE_TYPE_STR = FILE_TYPE.join(",");//所有文件类型

export const UN_READ_MESSAGE_COUNT = 0;//未读消息的数量
export const EDITOR_DOMAIN_NAME_URL = 'https://cmsitesapp.vsbclub.com/bookmarklet';//一键采集的链接地址
export const ZYK_HOST = "https://192.168.150.37/cm-sites-only-zyk";//资源库链接地址

export const ECXCEL_TYPE_ORIGINAL = ["xls","xlsx"];
export const ECXCEL_TYPE = [...ECXCEL_TYPE_ORIGINAL, ...ECXCEL_TYPE_ORIGINAL.toUpperCase()];//excel附件类型
export const ECXCEL_TYPE_STR = ECXCEL_TYPE.join(",");//附件类型

export const JSON_TYPE_ORIGINAL = ["json"];
export const JSON_TYPE = [...JSON_TYPE_ORIGINAL, ...JSON_TYPE_ORIGINAL.toUpperCase()];//json附件类型
export const JSON_TYPE_STR = ECXCEL_TYPE.join(",");//附件类型